import { Component, Vue} from 'vue-property-decorator'
import PlantingList from './PlantingList/PlantingList.vue'
import WorkRecordList from './WorkRecordList/WorkRecordList.vue'
import HarvestList from './HarvestList/HarvestList.vue'
import ShippingList from './ShippingList/ShippingList.vue'
import { LoginUser } from "@/types/Component";

@Component({
    components: {
        PlantingList,
        WorkRecordList,
        HarvestList,
        ShippingList
    }
})
export default class List extends Vue {
  navItem = "plantings"

  get isAdmin(): boolean {
    return this.loginUser.role.find((r: string) => {
      return r === 'ADMIN'
    }) !== undefined;
  }

  get loginUser(): LoginUser {
    return this.$store.getters.loginUser;
  }

  mounted() {
    this.$watch('$store.getters.currentPageName', this.currentMenu, { immediate: true });
  }

  currentMenu(){
    const path = this.$route.path
    const pathList = path.split('/')
    this.navItem = pathList[2]
  }
}